<template>
<div class="wrapper">
 <div class="columns">
  <div class="column is-9-widescreen is-9-tablet is-9-fullhd">
   <div class="columns">
      <div class="column">
        <back-button />
      </div>
    </div>
    <div class="blogs-page-detail" v-if="blogdata">
      <h1 class="is-size-3" >
        {{blogdata.title}}
      </h1>
      <div class="blog-date">{{ getBlogDate() }}</div>
      <div class="blog-content" v-html="blogdata.body"></div>
    </div>
    <div class="separation-line" v-if="blogs"></div>
    <div class="wrapper-all-blogs" v-if="blogs">
      <h1 class="is-size-3">
        See all Pickafund blog posts
      </h1>
      <div class="pt-3 mb-3">
        <div class="dropdown" :class="{ 'is-active': dropdownActive }">
            <div class="dropdown-trigger">
                <input
                type="text"
                class="input input-search"
                placeholder="Search"
                v-model="searchQuery"
                @focus="toggleDropdown(true)"
                @blur="toggleDropdown(false)"
                @input="onInput"
                ref="inputSearch"
                />
            </div>
            <!-- Dropdown Menu -->
            <div class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                <!-- Filtered Items -->
                <a
                    v-for="(item, index) in filteredItems"
                    :key="index"
                    class="dropdown-item"
                    target="_blank"
                    @mousedown.prevent="selectItem(item)"
                >
                    {{ item.title }}
                </a>
                <!-- No Items Found -->
                <div v-if="filteredItems.length === 0" class="dropdown-item">
                    No items found.
                </div>
                </div>
            </div>
        </div>
      </div>
      <div class="wrapper-blogs">
        <div v-for="blog in blogs.data" :key="blog.id">
          <a v-on:click="selectItem(blog)">{{ blog.title }}</a>
        </div>
      </div>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
    <div class="columns">
      <div class="column disclaimer">
          <Disclaimer />
      </div>
    </div>
  </div>
  <div ref="subRight_before" class="column is-3-tablet is-12-mobile is-3-widescreen banner-right is-3-fullhd">
    <div class="banner-on-top" ref="subRight">
        <AdsGoogle />
    </div>
  </div>
 </div>
</div>
</template>
<script>
import axios from "axios";
import BackButton from '@/components/BackButton.vue';
import Disclaimer from "@/components/Disclaimer";
import commonMixin from "@/mixins/commonMixin";
import Preloader from "@/components/Preloader";
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
    name: 'Blogpage',
    components: { BackButton, Disclaimer, Preloader, AdsGoogle },
    mixins: [commonMixin],
    data: function () {
        return {
            blogdata:null,
            blogs: null,
            dropdownActive: false,
            searchQuery: "",
            filteredItems: [],
        }
    },
    methods: {
      selectItem(item){
        axios.get("/blog/"+item.id).then(response => {
          this.blogdata = response.data;
          const { set } = this.$meta().addApp()
          set({
            title: this.blogdata.title + " | Pickafund",
          })
          window.scrollTo(0,0)
          history.pushState(null, '', '/blog/' + item.id + '/' + item.slug);
          this.searchQuery = '';
          this.filteredItems = [];
          this.$refs.inputSearch.blur();
        })
      },
      onInput() {
          const query = this.searchQuery.toLowerCase();
          if (query.trim() === '' ) {
              this.filteredItems = [];
          } else {
              this.filteredItems = this.blogs.data.filter((item) =>
                  item.title.toLowerCase().includes(query)
              );
          }
          
          if (!this.dropdownActive) this.toggleDropdown(true);
      },
      toggleDropdown(state) {
          this.dropdownActive = state;
      },
      getBlogDate() {
        const { published_date, created_at } = this.blogdata;
        return this.formatDateTime(published_date || created_at, "DD-MMM-YY");
      },
      getBlogs() {
          axios.get("/blog", {params: {limit: -1}}).then(response => {
            if (response)
              this.blogs = response.data
          })
      },
      getBlog() {
        axios.get("/blog/"+this.$route.params.id).then(response => {
          this.blogdata = response.data;
          const { set } = this.$meta().addApp()
          set({
            title: this.blogdata.title + " | Pickafund",
            meta: [
                { name: 'description', content:  'News & articles for valuable insight. Use Pickafund to convert these ideas by searching and comparing all Funds available to UK investors.'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
          })
        })
      }
    },
    async mounted(){
      await Promise.all([this.getBlog(), this.getBlogs()]);
    }
}
</script>
<style scoped lang="scss">
.blog {
  &-date {
    margin-top: -5px;
    padding-left: 5px;
    font-size: 15px;
  }
}
.blogs-page-detail {
  padding-bottom: 30px;
}
.wrapper {
  &-all-blogs {
    padding-top: 30px;
  }
  &-blogs {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;
    a {
      text-decoration: underline;
    }
  }
}
.separation-line {
  width: calc(100% - 60px);
  height: 1px;
  background-color: #bfbfbf;
}
.input-search {
    background-image: url(/img/search-icon.png);
    background-position: 8px center;
    background-repeat: no-repeat;
    padding-left: 1.75em;
    background-size: 21px;
}
.dropdown-menu .dropdown-content .dropdown-item {
    color: #009BDE;
}
.dropdown-menu .dropdown-content .dropdown-item:hover {
    background-color: #eee;
}
.dropdown-menu .dropdown-content {
    box-shadow: 0 0.5em 1em 0.25em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)
}
.dropdown-menu {
    overflow: visible;
}
.blog-content::v-deep * {
  all: revert;
}
</style>